import { type StateUiErrors } from '~shared/reducers/ui/errors';
import { type ReduxStateShared } from '~shared/types';

const getErrors: (state: ReduxStateShared) => StateUiErrors = (state) => state.ui.errors;

export default getErrors;
